import moment from 'moment'
import { endTimeFromLength } from '../utils'
import appInsights, {
  SeverityLevel,
} from '../../../components/logging/appInsights'
import {
  trackCancelAppointment,
  trackUpdateAppointment,
} from '../../../../utils/tracker'
import { user } from '../../../../utils/initValues'
import {
  cancelAppointment,
  updateAppointmentDetails,
} from '../../../../utils/badaAppointmentApi'

export const isValid = (formData, timeOptions, lengthOptions) => {
  let valid = true
  let reason = null
  if (!formData.newSelectedTime) {
    valid = false
    reason = 'Please select time.'
  }
  if (!formData.newStoreId) {
    valid = false
    reason = 'Please select store.'
  }
  if (!formData.newServiceProviderId) {
    valid = false
    reason = 'Please select schedule.'
  }

  if (!formData.newSelectedDate) {
    valid = false
    reason = 'Please select date.'
  }
  if (!formData.newSelectedTime) {
    valid = false
    reason = 'Please select valid start time.'
  }
  if (!formData.newSelectedEndTime) {
    valid = false
    reason = 'Please select end time.'
  }
  if (
    moment(`${formData.newSelectedDate} ${formData.newSelectedTime}`) < moment()
  ) {
    valid = false
    reason = 'Date must be in the future.'
  }
  if (
    moment(`1970-01-01 ${formData.newSelectedTime}`) >=
    moment(
      `1970-01-01 ${endTimeFromLength(
        formData.newSelectedTime,
        formData.newSelectedLength
      )}`
    )
  ) {
    valid = false
    reason = 'End time must be after start time.'
  }
  const timeOption = timeOptions.find(
    (t) => t.value === formData.newSelectedTime
  )
  const lengthOption = lengthOptions.find(
    (t) => t.value === formData.newSelectedLength
  )
  const validTime = timeOption && !timeOption.disabled
  const validDuration = lengthOption && !lengthOption.disabled

  if (!validTime) {
    valid = false
    reason = 'Invalid time selected'
  }
  if (!validDuration) {
    valid = false
    reason = 'Invalid duration selected'
  }
  return { valid, reason }
}

export const hasAppointmentChanges = (formData) =>
  formData.oldSelectedDate !== formData.newSelectedDate ||
  formData.oldSelectedTime !== formData.newSelectedTime ||
  formData.oldSelectedEndTime !== formData.newSelectedEndTime ||
  formData.oldServiceProviderId !== formData.newServiceProviderId ||
  formData.oldStoreId !== formData.newStoreId ||
  formData.oldServiceId !== formData.newServiceId

export const update = (
  appointmentId,
  formData,
  setLoading,
  setError,
  onUpdate,
  timeOptions,
  lengthOptions,
  onSuccessfulSave
) => {
  const validation = isValid(formData, timeOptions, lengthOptions)
  if (!validation.valid) {
    /* eslint-disable no-alert */
    alert(JSON.stringify(formData))
    return Promise.resolve()
  }

  setLoading(true)
  setError(null)

  const updatedBy = user?.email || 'store'
  const updatedByName = user?.name || ''

  return updateAppointmentDetails(appointmentId, {
    serviceId: parseInt(formData.newServiceId, 10),
    serviceProviderId: parseInt(formData.newServiceProviderId, 10),
    selectedDate: formData.newSelectedDate,
    selectedTime: formData.newSelectedTime,
    selectedEndTime: endTimeFromLength(
      formData.newSelectedTime,
      formData.newSelectedLength
    ),
    updatedBy,
    updatedByName,
  })
    .then(() => {
      const changes = [
        formData.oldServiceId !== formData.newServiceId && 'service',
        formData.oldSelectedDate !== formData.newSelectedDate && 'date',
        (formData.oldSelectedTime !== formData.newSelectedTime ||
          formData.oldSelectedEndTime !== formData.newSelectedEndTime) &&
          'time',
        formData.oldServiceProviderId !== formData.newServiceProviderId &&
          'designer',
      ]
        .filter(Boolean)
        .join(', ')
      trackUpdateAppointment(appointmentId, changes, true)
      if (typeof onSuccessfulSave === 'function') {
        onSuccessfulSave()
      }
      onUpdate()
    })
    .catch((error) => {
      const message = error && error.message
      appInsights.trackException({
        exception: new Error('Failed to update appointment details.'),
        severityLevel: SeverityLevel.Error,
      })
      setError(
        message || 'Failed to update appointment. Please try again later.'
      )
    })
    .finally(() => {
      setLoading(false)
    })
}

export const cancel = (appointmentId, setLoading, onCancel) => {
  setLoading(true)
  /* eslint-disable no-alert */
  if (confirm('Are you sure you want to cancel the appointment?')) {
    cancelAppointment(appointmentId, 'store').then(() => {
      setLoading(false)
      trackCancelAppointment(appointmentId, true)
      onCancel()
    })
  } else {
    setLoading(false)
  }
}
